import React, { JSX, useState } from "react";
import { Outlet } from "react-router";
import {
    ProductSearchContext,
    ProductSearchCriteria,
    defaultProductSearchCriteria,
} from "utilities/contexts/search/product/product-search-context";

// -------------------------------------------------------------------------------------------------
// #region Interfaces
// -------------------------------------------------------------------------------------------------

interface AdminProductLayoutProps {}

// #endregion Interfaces

// -------------------------------------------------------------------------------------------------
// #region Component
// -------------------------------------------------------------------------------------------------

// Keeps ProductSearchCriteria in scope across the product list page and its detail routes, without leaking to other admin sections.
const AdminProductLayout: React.FC<AdminProductLayoutProps> = (): JSX.Element => {
    const [productSearchCriteria, setProductSearchCriteria] = useState<ProductSearchCriteria>(
        defaultProductSearchCriteria
    );

    return (
        <ProductSearchContext.Provider
            value={{ initialCriteria: productSearchCriteria, setCriteria: setProductSearchCriteria }}>
            <Outlet />
        </ProductSearchContext.Provider>
    );
};

// #endregion Component

// -------------------------------------------------------------------------------------------------
// #region Exports
// -------------------------------------------------------------------------------------------------

export { AdminProductLayout, AdminProductLayout as ProductSearchLayout };

// #endregion Exports
